export default from './search-results-list';



// WEBPACK FOOTER //
// ./app/components/search-results-list/index.js